// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section_wrapper__3F3Fi","section":"Section_section__1wOiW"};